e4.search = {
    init: function () {
        if (jQuery('.js-e-search').length > 0) {
            jQuery.when.apply(jQuery, [
                e4.require.js(e4.settings.require.handlebars),
                e4.require.js(e4.settings.require.typeahead)
            ]).then(function () {
                e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-search-result-item-product #js-e-handlebars-tmpl-search-result-item-page');
                e4.search.event = e4.util.registerEvents('loaded', 'search');
                e4.search.bindEvents();
                if (e4.hash.get('search') !== undefined) {
                    jQuery('.js-e-search-modal').filter(':not(.show)').modal('show');
                }
                
            });
        }
    },
    bindEvents: function () {
        jQuery('.js-e-search-clear').on('click', function (event) {
            let jTargetElement = jQuery(event.currentTarget);
            let jInputGroupContainer = jTargetElement.closest('.js-e-search-input-group');
            let jInputSearchField = jInputGroupContainer.find('.js-eldorado-search-input');
            jInputSearchField.val('');
            jInputSearchField.trigger('input');
        });
        
        jQuery('.js-eldorado-search-input')
            .on('input', function (event){
                e4.search.toggleClearBtn(event);
            })
            .on('keydown', function (event) {
                if (event.keyCode === 13) {
                    jQuery(event.currentTarget).closest('form').submit();
                }
            }).typeahead({
            input: null,
            hint: false,
            highlight: true,
            minLength: e4.settings.search.inputMinLength,
            classNames: {
                input: 'js-eldorado-productsearch-input',
                wrapper: 'eldorado-productsearch-typeahead-wrapper js-eldorado-productsearch-typeahead-wrapper w-100',
                menu: 'js-eldorado-productsearch-suggestions eldorado-productsearch-suggestions dropdown-menu w-100',
                dataset: 'row col-12 col-md-10 mx-auto',
                //suggestion: 'js-eldorado-productsearch-suggestions-item dropdown-item col-6 col-sm-6 col-md-3 d-flex',
                open: 'open',
                cursor: 'active',
                highlight: 'active'
            }
        }, {
            name: 'espresso',
            display: function (suggestion) {

            },
            limit: 4,
            async: true,
            source: e4.util.debounce(function (query, syncResults, asyncResults) {
                e4.search.getSuggestions(query, function (products) {
                    asyncResults(products);
                });
            }, e4.settings.debounceDelay.input),
            templates: {
                pending: function (data) {
                },
                header: function (data) {
                },
                suggestion: function (data) {
                    return '<div class="js-eldorado-productsearch-suggestions-item col-6 col-sm-6 col-md-3 d-flex px-1">' + data.listItemHtml + '</div>';
                },
                footer: function (data) {
                    return '<a href="' + e4.settings.area.urlName + '/search?q=' + data.query + '" class="btn btn-block btn-primary js-eldorado-submit-search-btn m-1">Vis alle produkter</a>';
                }
            }
        }).on('typeahead:select', function (event, product) {
            e4.search.preventTypeaheadSuggestionsClose = true;
        }).on('typeahead:close', function () {
            if (e4.search.preventTypeaheadSuggestionsClose) {
                e4.search.preventTypeaheadSuggestionsClose = false;
                jQuery('.js-eldorado-search-input').typeahead('open');
            }
        });
    },
    toggleClearBtn: function (event) {
        let jTargetElement = jQuery(event.currentTarget);
        let jInputGroupContainer = jTargetElement.closest('.js-e-search-input-group');
        if (jTargetElement.val() !== ''){
            jInputGroupContainer.removeClass('is-empty');
        }else if (jInputGroupContainer.hasClass('is-empty') === false){
            jInputGroupContainer.addClass('is-empty');
        }
    },
    preventTypeaheadSuggestionsClose: false,
    getSuggestions: function (query, asyncResults) {
        if (this.jqXHR !== undefined && this.jqXHR.readyState !== 4) {
            this.jqXHR.abort();
        }
        query = jQuery.trim(query);
        if (query !== '') {
            this.jqXHR = jQuery.ajax({
                method: 'GET',
                url: e4.settings.search.result.products.rawurl,//e4.settings.ecom.quickorder.url,
                data: {
                    q: query//, searchQuery: query
                    //productNumbers: ''
                },
                dataType: 'json'
            });
            this.jqXHR.done(function (data) {
                if (data.products.length === 0) {
                    jQuery('.js-eldorado-productsearch-suggestions-item').remove();
                    jQuery('.js-eldorado-submit-search-btn').remove();
                }
                asyncResults(data.products);
            });

        }
    },
    loadIndex: function () {
        if (e4.settings.search.result.products.show === true) {
            jQuery.get(e4.settings.search.result.products.url + (new Date()).getTime());
        }
        if (e4.settings.search.result.pages.show === true) {
            jQuery.get(e4.settings.search.result.pages.url + (new Date()).getTime());
        }
    },
    initInputFieldAndHash: function (event) {
        var jSearchInput = jQuery(event.target).find('.js-e-search-input'),
            strQuery = jSearchInput.val(),
            strHashSearch = e4.hash.get('search');
        if (strHashSearch !== undefined && strHashSearch !== '') {
            jSearchInput.val(strHashSearch).triggerHandler('input');
        } else if (strQuery !== '') {
            e4.hash.set('search', strQuery);
            jSearchInput.triggerHandler('input');
        } else {
            e4.hash.set('search');
        }
        jSearchInput.trigger('focus');
    },
    cleanUpInputFieldAndHash: function (event) {
        var jSearchInput = jQuery(event.target).find('.js-e-search-input');
        jQuery('.js-e-search-form-inline').find('.js-e-search-input').val(jSearchInput.val());
        jSearchInput.trigger('blur');
        if (e4.hash.get('search') !== undefined) {
            e4.hash.remove('search');
        }
    },
    toggleInputGroupState: function (domNode) {
        var jSearchInputGroup = jQuery(domNode).closest('.js-e-search-input-group');
        if (domNode.value === '') {
            jSearchInputGroup.addClass('is-empty');
        } else {
            jSearchInputGroup.removeClass('is-empty');
        }
    },
    clearInput: function (domNode) {
        jQuery(domNode).closest('.js-e-search-input-group').find('.js-e-search-input').val('').trigger('focus')
            .triggerHandler('input');
    },
    result: {
        get: function (domNode) {
            var jSearch = jQuery(domNode).closest('.js-e-search'),
                arrPromises = [];
            jSearch.find('.js-e-search-loading-overlay').addClass('is-loading');
            if (jQuery.trim(domNode.value) !== '' && domNode.value.length >= e4.settings.search.inputMinLength) {
                if (e4.settings.search.result.products.show === true) {
                    arrPromises.push(e4.search.result.products.get(domNode));
                }
                if (e4.settings.search.result.pages.show === true) {
                    arrPromises.push(e4.search.result.pages.get(domNode));
                }
            } else {
                if (e4.settings.search.result.products.show === true) {
                    arrPromises.push(e4.search.result.products.abort(domNode));
                }
                if (e4.settings.search.result.pages.show === true) {
                    arrPromises.push(e4.search.result.pages.abort(domNode));
                }
                jSearch.find('.js-e-search-loading-overlay').removeClass('is-loading');
            }
            return jQuery.when.apply(jQuery, arrPromises).then(function () {
                e4.search.result.count = e4.search.result.products.count + e4.search.result.pages.count;
                jQuery(domNode).closest('.js-e-search-form').trigger(e4.search.event.loaded, {
                    query: jQuery.trim(domNode.value),
                    resultCount: e4.search.result.count
                });
                e4.search.result.show(domNode);
            }, function () {
                e4.search.result.hide(domNode);
            });
        },
        show: function (domNode) {
            var jSearch = jQuery(domNode).closest('.js-e-search');
            jSearch.find('.js-e-search-result-container').addClass('is-active');
            jSearch.find('.js-e-search-result-count').text(e4.search.result.count);
            jSearch.find('.js-e-search-loading-overlay').removeClass('is-loading');
        },
        hide: function (domNode) {
            var jSearch = jQuery(domNode).closest('.js-e-search');
            jSearch.find('.js-e-search-result-container').removeClass('is-active');
            e4.search.result.products.clear(domNode);
            e4.search.result.pages.clear(domNode);
        },
        products: {
            jqXhr: null,
            count: 0,
            get: function (domNode) {
                if (e4.search.result.products.jqXhr !== null && e4.search.result.products.jqXhr.readyState !== 4) {
                    e4.search.result.products.jqXhr.abort();
                }
                e4.search.result.products.jqXhr = jQuery.ajax({
                    url: e4.settings.search.result.products.url + encodeURIComponent(jQuery.trim(domNode.value)),
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                }).done(function (jsonData) {
                    e4.search.result.products.update(domNode, jsonData);
                }).fail(function (jqXhr, strTextStatus, objError) {
                    if (strTextStatus !== 'abort') {
                        console.error(objError);
                    }
                });
                return e4.search.result.products.jqXhr;
            },
            abort: function () {
                if (e4.search.result.products.jqXhr !== null && e4.search.result.products.jqXhr.readyState !== 4) {
                    return e4.search.result.products.jqXhr.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function (domNode, jsonData) {
                e4.search.result.products.count = jsonData.products.length;
                if (e4.search.result.products.count > 0) {
                    var jSearch = jQuery(domNode).closest('.js-e-search'),
                        intMaxResults = (e4.settings.search.result.pages.show === true) ? e4.settings.search.result.products.max[e4.util.getBreakPoint()] : 120,
                        jsonDataSliced = {
                            products: jsonData.products.slice(0, intMaxResults)
                        };
                    jSearch.find('.js-e-search-result-products')
                        .html(e4.handlebars.tmpl.searchResultItemProduct(jsonDataSliced)).removeClass('is-empty');
                    e4.search.result.products.toggleShowAllLink(domNode, jsonData, intMaxResults);
                } else {
                    e4.search.result.products.clear(domNode);
                }
            },
            clear: function (domNode) {
                jQuery(domNode).closest('.js-e-search').find('.js-e-search-result-products').addClass('is-empty')
                    .html('');
            },
            toggleShowAllLink: function (domNode, jsonData, intMaxResults) {
                var jShowAllLink = jQuery(domNode).closest('.js-e-search').find('.js-e-search-products-show-all');
                if (e4.search.result.products.count > intMaxResults) {
                    jShowAllLink.find('a').attr('href', e4.settings.search.result.products.showAllLink + domNode.value)
                        .on('click', {
                            'domNode': domNode,
                            'products': jsonData
                        }, e4.search.result.products.showAll);
                } else {
                    jShowAllLink.addClass('d-none');
                    jShowAllLink.find('a').off('click', e4.search.result.products.showAll);
                }
            },
            showAll: function (event) {
                if (e4.search.result.products.count > 0 && event.data !== undefined) {
                    event.preventDefault();
                    var jSearch = jQuery(event.data.domNode).closest('.js-e-search');
                    jSearch.find('.js-e-search-result-products')
                        .html(e4.handlebars.tmpl.searchResultItemProduct(event.data.products)).removeClass('is-empty');
                    jSearch.find('.js-e-search-products-show-all').addClass('d-none');
                }
            }
        },
        pages: {
            jqXhr: null,
            count: 0,
            get: function (domNode) {
                if (e4.search.result.pages.jqXhr !== null && e4.search.result.pages.jqXhr.readyState !== 4) {
                    e4.search.result.pages.jqXhr.abort();
                }
                e4.search.result.pages.jqXhr = jQuery.ajax({
                    url: e4.settings.search.result.pages.url + encodeURIComponent(jQuery.trim(domNode.value)),
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                }).done(function (jsonData) {
                    e4.search.result.pages.update(domNode, jsonData);
                }).fail(function (jqXhr, strTextStatus, objError) {
                    if (strTextStatus !== 'abort') {
                        console.error(objError);
                    }
                });
                return e4.search.result.pages.jqXhr;
            },
            abort: function () {
                if (e4.search.result.pages.jqXhr !== null && e4.search.result.pages.jqXhr.readyState !== 4) {
                    return e4.search.result.pages.jqXhr.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function (domNode, jsonData) {
                e4.search.result.pages.count = jsonData.pages.length;
                if (e4.search.result.pages.count > 0) {
                    var jSearch = jQuery(domNode).closest('.js-e-search');
                    jSearch.find('.js-e-search-result-pages').html(e4.handlebars.tmpl.searchResultItemPage(jsonData))
                        .removeClass('is-empty');
                } else {
                    e4.search.result.pages.clear(domNode);
                }
            },
            clear: function (domNode) {
                jQuery(domNode).closest('.js-e-search').find('.js-e-search-result-pages').addClass('is-empty').html('');
            }
        }
    }
};
